import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authLink } from '../lib/authNavigation';

export function StandardsAccessGate({ title = 'Standards library' }: { title?: string }) {
  const { isLoading } = useAuth();
  const location = useLocation();
  const returnTo = `${location.pathname}${location.search}${location.hash}`;
  if (isLoading) return <p role="status">Checking your account…</p>;
  return <section className="docs-content standards-access">
    <div className="crumb">AstdZ / standards access</div>
    <h1>{title}</h1>
    <p>Create an account or sign in to read full specifications, search the complete message libraries, and download the standards.</p>
    <p className="text-muted">Your account gives you access to the documents. Certification is a separate step for using the hosted encoder.</p>
    <div className="content-actions">
      <Link className="btn btn-primary" to={authLink('/signup', returnTo)}>Create account →</Link>
      <Link className="btn" to={authLink('/login', returnTo)}>Sign in →</Link>
    </div>
    <p><Link to="/docs/standards">Browse the standards catalog</Link></p>
  </section>;
}
